import FormSection from './FormSection';
import SearchableDropdown from '../../../../../components/SearchableDropdown';
import { labelCls, errorCls, hintCls, controlCls } from './formStyles';
import { ID_PROOF_TYPES, ID_PROOF_LABEL, LIMITS } from '../../visitorConstants';

const PROOF_OPTIONS = ID_PROOF_TYPES.map(t => ({ value: t, label: ID_PROOF_LABEL[t] || t }));

const IdProofFields = ({ form, errors, set, required = false }) => {
    // Unlike visitor type, this field is optional — "not recorded" is a real
    // state, so clearing stays enabled. The dropdown signals a clear with the
    // literal 'all' (a filter-dropdown sentinel), which has to become '' here or
    // it would reach the API as an invalid enum.
    const handleTypeChange = (raw) => {
        const next = raw === 'all' ? '' : raw;
        set('id_proof_type', next);
        // A number with no type is meaningless and its input is about to be
        // disabled, so don't leave an orphaned value stranded in it.
        if (!next) set('id_proof_number', '');
    };

    return (
        <FormSection
            icon="mdi:card-account-details-outline"
            title="Identification"
            hint={required
                ? 'Required by your society — recorded once so the gate does not re-check on every visit'
                : 'Optional — recorded once so the gate does not re-check on every visit'}
        >
            <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-3 tw-gap-3">
                <div>
                    <label className={labelCls}>Document type{required && <span className="tw-text-rose-500"> *</span>}</label>
                    <SearchableDropdown
                        small
                        clearable={!required}
                        value={form.id_proof_type || ''}
                        onChange={handleTypeChange}
                        options={PROOF_OPTIONS}
                        placeholder="Not recorded"
                    />
                    {errors.id_proof_type && <p className={errorCls}>{errors.id_proof_type}</p>}
                </div>

                <div>
                    <label className={labelCls}>Document number{required && <span className="tw-text-rose-500"> *</span>}</label>
                    {/* A number with no document type is meaningless, so the field
                        stays locked until a type is chosen. */}
                    <input
                        type="text"
                        value={form.id_proof_number || ''}
                        onChange={e => set('id_proof_number', e.target.value)}
                        maxLength={LIMITS.id_proof_number}
                        placeholder="e.g. 1234-5678-9012"
                        disabled={!form.id_proof_type}
                        className={`${controlCls(!!errors.id_proof_number)} tw-font-mono disabled:tw-bg-gray-50 disabled:tw-text-gray-400`}
                    />
                    {errors.id_proof_number
                        ? <p className={errorCls}>{errors.id_proof_number}</p>
                        : !form.id_proof_type && <p className={hintCls}>Pick a document type first</p>}
                </div>

                <div>
                    <label className={labelCls}>Photo URL</label>
                    <input
                        type="url"
                        value={form.photo_url || ''}
                        onChange={e => set('photo_url', e.target.value)}
                        maxLength={LIMITS.photo_url}
                        placeholder="https://..."
                        className={controlCls(!!errors.photo_url)}
                    />
                    {errors.photo_url
                        ? <p className={errorCls}>{errors.photo_url}</p>
                        : <p className={hintCls}>Upload elsewhere, paste the link here</p>}
                </div>
            </div>
        </FormSection>
    );
};

export default IdProofFields;
